<template>
  <div class="home">
    <!-- <listquery class="listquery" @queryDatas="querydata"></listquery> -->
    <leftpage class="homel" v-if="btnactivelen==0"></leftpage>
    <rightpage class="homer" v-if="btnactivelen==0" style="width:500px"></rightpage>
    <!-- <Ldwgc class="homel" v-if="btnactivelen==3" :gisclick="gisrightdata"></Ldwgc> -->
    <basicinformationdetails class="homel" v-if="btnactivelen==3" :gisclick="gisrightdata"></basicinformationdetails>
    <Rdwgc class="homer" v-if="btnactivelen==3" :gisclick="gisrightdata"></Rdwgc>
  </div>
</template>

<script>
  import leftpage from "./leftPage.vue";
  import rightpage from "./rightPage.vue";
  import Ldwgc from "./Ldwgc.vue";
  import Rdwgc from "./Rdwgc.vue";
  import basicinformationdetails from "../Basicinformation/BasicinformationDetails.vue";
  import listquery from "@/components/visualization/LlistQuery.vue";

  export default {
    props: ["gisClick", "map", "querydatas"],
    data() {
      return {
        // btn:[
        // 	{name:"统计信息",id:0},
        // 	{name:"列表检索",id:1},
        // ],
        btnactivelen: 0,
        gisrightdata: null,
      };
    },
    components: {
      leftpage,
      rightpage,
      Ldwgc,
      Rdwgc,
      basicinformationdetails,
      listquery,
    },
    computed: {
      fanhuiStatus() {
        return this.$store.state.fanhuiShow; //需要监听的数据
      },
    },
    watch: {
      gisClick: {
        handler(newVal, oldVal) {
          let _this = this;
          if (newVal != null) {
            this.btnactivelen = 3;
            setTimeout(function() {
              _this.gisrightdata = newVal;
            }, 200);
          }
        },
        immediate: true,
        deep: true,
      },
      querydatas(data, data1) {
        let _this = this;
        if (data.children.length == 0) {
          this.btnactivelen = 3;
          this.$store.commit('fanhuiFun', false); //token
          this.map.setView([Number(data.ydbWeiDu), Number(data.ydbJingDu)], 15);
          setTimeout(function() {
            _this.gisrightdata = data;
          }, 200);
          // this.gisrightdata = data;
        } else if (data.children[0] == 0) {
          this.btnactivelen = 0;
          this.$store.commit('fanhuiFun', true); //token
        } else {
          setTimeout(function() {
            _this.gisrightdata = data;
          }, 200);
          this.btnactivelen = 0;
          this.$store.commit('fanhuiFun', false); //token
        }
      },
      fanhuiStatus(newVal, oldVal) {
        // console.log('---->返回--',newVal)
        if (newVal == true) {
          this.btnactivelen = 0;
        }
      },
    },
    methods: {
      btnClick(item, i) {
        this.btnactivelen = i;
      },
      // querydata(data) {
      //   let _this = this;
      //   if (data.children.length == 0) {
      //     this.btnactivelen = 3;
      //     this.$store.commit("fanhuiFun", false); //token
      //     this.map.setView([Number(data.ydbWeiDu), Number(data.ydbJingDu)], 15);
      //     setTimeout(function() {
      //       _this.gisrightdata = data;
      //     }, 200);
      //   } else if (data.children[0] == 0) {
      //     this.btnactivelen = 0;
      //     this.$store.commit('fanhuiFun', true); //token
      //   } else {
      //     setTimeout(function() {
      //       _this.gisrightdata = data;
      //     }, 200);
      //     this.btnactivelen = 0;
      //     this.$store.commit('fanhuiFun', false); //token
      //   }
      // },
    },
  };
</script>

<style scoped="scoped">
  .home {
    position: fixed;
    z-index: 1;
    height: 100%;
  }

  .homel,
  .homer {
    width: 360px;
    position: fixed;
    z-index: 100;
    top: 130px;
    overflow: auto;
    background: transparent;
    bottom: 30px;
  }

  .homel {
    left: 10px;
  }

  .homer {
    right: 10px;
  }
</style>
